import { useCallback, useEffect, useState } from "react";
import { caseListTableClasses } from "../../../../components/common/caseListClasses";
import useAxios from "../../../../hooks/useAxios";
import { errorToast, successToast } from "../../../../utils/toast";
import { INTEGRATION_PARTNER_MAP } from "../../../../utils/enum";
import { RenderIf } from "../../../../components";
import XLoader from "../../../../components/common/XLoader";
import XButton from "../../../../components/common/XButton";
import { cardTitleClasses } from "../../../../components/common/formClasses";

const ApiKeySection = ({
  title,
  buttonText,
  modal: ModalComponent,
  getApiUrl,
  deleteApiUrl
}) => {
  const { getData, isLoading, deleteData } = useAxios();
  const [apiList, setApiList] = useState([]);
  const [isShowModal, setShowModal] = useState(false);

  const revokeApiKey = async (partnerId) => {
    const postRes = await deleteData(`${deleteApiUrl}/${partnerId}`);

    if (!postRes.success) {
      errorToast(postRes?.message || "There is some error. Please try again.");
      return;
    }

    successToast("API key successfully revoked");
    getApiKeys();
  };

  const getApiKeys = useCallback(async () => {
    const { success, data } = await getData(getApiUrl);
    if (success) {
      setApiList(data || []);
    }
  }, [getData, getApiUrl]);

  useEffect(() => {
    getApiKeys();
  }, [getApiKeys]);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-surface mb-12! px-5 py-[calc(var(--spacing)*7.5)] shadow-[0_0_20px_rgba(16,24,40,0.15)] rounded-[calc(var(--spacing)*2.5)]">
        <div className={`title ${cardTitleClasses}`}>
          <h2>{title}</h2>
        </div>
        <div className="row">
          <div className="col-md-6">
            <XButton
              onClick={() => setShowModal(true)}
              className="ml-2! min-w-62.5"
            >
              <i className="fa-solid fa-plus mr-2!"></i> {buttonText}
            </XButton>
          </div>
        </div>

        <table className={`dp-table mt-12! ${caseListTableClasses}`}>
          <thead>
            <tr>
              <th>Partner Name</th>
              <th>Key</th>
              <th>Revoke</th>
            </tr>
          </thead>
          <tbody>
            <RenderIf shouldRender={!isLoading}>
              {apiList?.length > 0 &&
                apiList.map((key, i) => (
                  <tr key={i}>
                    <td>{INTEGRATION_PARTNER_MAP[key.partnerId]?.text}</td>
                    <td>
                      <span className="pr-4!">{key.maskedApiKey}</span>
                    </td>
                    <td>
                      <XButton
                        variant="outlinePrimary"
                        onClick={() => revokeApiKey(key.partnerId)}
                        className="ml-2! min-w-20"
                      >
                        Revoke
                      </XButton>
                    </td>
                  </tr>
                ))}
            </RenderIf>

            {isLoading && (
              <tr>
                <td colSpan={3}>
                  <div className="flex justify-center">
                    <XLoader />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isShowModal && ModalComponent && (
        <ModalComponent setShowModal={setShowModal} getApiKeys={getApiKeys} />
      )}
    </>
  );
};

export default ApiKeySection;
